import { useFetch } from '#/hooks/use-fetch';
// import { ROUTES } from '#/data/constants';

export function useFileService(): PackageService {
  const client = useFetch();

  return {
    download: async (fileName, oriPath, ext, isDown) => {
      return await client.formDownload(`/`, {
        fileName: fileName,
        oriPath: oriPath,
        ext: ext,
        isDown: isDown
      });
    },
    upload: async (fileName, file) => {
      return await client.upload(`/`, {
        fileName: fileName,
        file: file
      });
    }
  };
}

interface PackageService {
  download: (
    fileName: string,
    oriPath: string,
    ext: string,
    isDown: boolean
  ) => Promise<any>;
  upload: (fileName: string, file: File) => Promise<any>;
}
